<template>
  <MobileContainer :class="$style.container">
    <MobileHeader slot="header"
                  nav-action="home"
    >
      Burger Boss - {{ restaurant.city }}
    </MobileHeader>
    <div :class="$style.main">
      <div :class="$style.mainTop">
        <p :class="$style.welcomText">
          Welcome Back, {{ user.firstName | capitalize }}!
        </p>
        <p :class="$style.lastOrdersText">
          Here’s your last 5 orders
        </p>
      </div>
      <div :class="$style.mainBottom">
        <VList v-if="isOrdersLoaded"
               :class="$style.ordersList">
          <VListTile v-for="(order, index) in lastFiveOrders"
                     :key="index"
                     :class="$style.ordersListItem"
                     ripple>
            <Order :order="order"
                   @save-to-cart="saveToCart"/>
          </VListTile>
        </VList>
      </div>
    </div>
  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import Order from '@/apps/cart/components/Order';
import { Getter, Action } from 'vuex-class';
import { CART_SAVE_ORDER, CART_DISPLAY, ORDERS_LOAD } from '@/apps/cart/store/types';

/**
 * Mobile past order page.
 */
@Component({
  components: {
    MobileContainer,
    MobileHeader,
    Order,
  },
})
export default class MobilePastOrders extends Vue {
  @Getter('authUser') user;
  @Getter products;
  @Getter restByKey;
  @Getter restaurantId;
  @Getter orders;
  @Action(CART_SAVE_ORDER) saveOrderToCart;
  @Action(CART_DISPLAY) displayCart;
  @Action(ORDERS_LOAD) loadOrders;

  restaurant = null;

  isOrdersLoaded = false;

  created() {
    this.restaurant = this.restByKey(this.restaurantId);
    this.loadOrders();
    this.isOrdersLoaded = true;
  }

  /**
   * Get last 5 orders for current user (sorted by date).
   */
  get lastFiveOrders() {
    const sortedOrders = this.orders
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    if (sortedOrders.length > 5) {
      return sortedOrders.slice(sortedOrders.length - 5);
    }

    return sortedOrders;
  }

  saveToCart(order) {
    this.saveOrderToCart(order);
    this.displayCart(true);
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
@import "@/style/helpers.scss";

.container {
  background: $mobile-gray-bg;
}

.main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  padding: 10px 0 20px;

  &Top,
  &Bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  &Top {
    justify-content: center;
  }
  &Bottom {
    flex: 1 0 auto;
  }
}

.welcomText {
  color: $green-color;
  font-family: $decor-font-family;
  font-size: rem(24px);
  letter-spacing: rem(0.67px);
  text-align: center;
  margin: 10px 0 5px 0;
}

.lastOrdersText {
  color: $black-semi-transparent;
  font-family: $main-font-family;
  font-size: rem(12px);
  font-style: italic;
  font-weight: 300;
  text-align: center;
}

.ordersList {
  width: 100%;

  &Item {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobilePastOrders.vue